<template>
  <div style="max-width: 500px" class="mx-auto">
    <div
      class="Kanit primary pa-4 text-center white--text"
      style="font-size: 22px"
    >
      แก้ไขข้อมูล
    </div>
    <div>
      <v-btn @click="$emit('close')" text color="primary">
        <v-icon>mdi-chevron-left</v-icon>
        กลับ
      </v-btn>
    </div>
    <div class="pa-5 pt-2">
      <ValidationObserver ref="observer">
        <ValidationProvider
          :rules="{
            required: true,
          }"
          name="ชื่อ"
          v-slot="{ errors }"
        >
          <div class="grey--text">ชื่อ <span class="red--text"> *</span></div>

          <custom-input
            v-model="input.firstName"
            dense
            outlined
            :error-messages="errors"
          ></custom-input>
        </ValidationProvider>
        <ValidationProvider
          :rules="{
            required: true,
          }"
          name="นามสกุล"
          v-slot="{ errors }"
        >
          <div class="grey--text">
            นามสกุล <span class="red--text"> *</span>
          </div>

          <custom-input
            v-model="input.lastName"
            dense
            outlined
            :error-messages="errors"
          ></custom-input>
        </ValidationProvider>
        <ValidationProvider
          :rules="{
            email: true,
          }"
          name="อีเมล"
          v-slot="{ errors }"
        >
          <div class="grey--text">อีเมล</div>

          <custom-input
            v-model="input.email"
            dense
            outlined
            :error-messages="errors"
          ></custom-input>
        </ValidationProvider>
        <ValidationProvider
          :rules="{
            required: true,
          }"
          name="วัน-เดือน-ปี เกิด"
          v-slot="{ errors }"
        >
          <div class="grey--text">
            วัน-เดือน-ปี เกิด <span class="red--text"> *</span>
          </div>
          <div style="width: 60%">
            <BirthdayPicker v-model="input.dob">
              <custom-input
                :value="
                  input.dob
                    ? moment(input.dob)
                        .add(543, 'year')
                        .format('DD/MM/YYYY')
                    : ''
                "
                placeholder="DD/MM/YYYY"
                dense
                readonly
                outlined
                appendOuterIcon="mdi-calendar"
                :error-messages="errors"
              ></custom-input>
            </BirthdayPicker>
          </div>
        </ValidationProvider>
        <ValidationProvider
          :rules="{
            required: true,
          }"
          name="อาชีพ"
          v-slot="{ errors }"
        >
          <div class="grey--text">อาชีพ <span class="red--text"> *</span></div>

          <v-select
            v-model="input.job"
            dense
            :items="jobOptions"
            outlined
            :error-messages="errors"
          ></v-select>
        </ValidationProvider>
        <!-- <ValidationProvider
          :rules="{
            required: true,
            digits: 13,
          }"
          name="เลขบัตรประชาชน"
          v-slot="{ errors }"
        >
          <div class="grey--text">
            เลขบัตรประชาชน <span class="red--text"> *</span>
          </div>

          <custom-input
            v-model="input.identityNumber"
            dense
            maxlength="13"
            outlined
            numberOnly
            :error-messages="errors"
          ></custom-input>
        </ValidationProvider> -->
        <ValidationProvider name="รูปบัตรประชาชน" v-slot="{ errors }">
          <div class="grey--text">
            <span class="pr-1">แนบบัตรประชาชน</span>
            <v-tooltip bottom color="#2a72c3">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" color="red">
                  mdi-alert-circle-outline
                </v-icon>
              </template>
              <div class="white--text">
                หากไม่แนบบัตรประชาชน จะไม่สามารถแลกของรางวัลได้
              </div>
            </v-tooltip>
          </div>
          <UploadSingleFile
            v-model="input.identityNumberImage"
            :errors="errors"
          ></UploadSingleFile>
        </ValidationProvider>
      </ValidationObserver>
      <div class="text-center">
        <v-btn :loading="saveloading" class="mt-2" @click="next" color="primary"
          >บันทึก</v-btn
        >
      </div>
    </div>
  </div>
</template>

<script>
import BirthdayPicker from "@/components/BirthdayPicker.vue";
import UploadDocument from "@/components/UploadDocument.vue";
import UploadSingleFile from "@/components/UploadSingleFile.vue";
import moment from "moment";
import axios from "axios";
export default {
  components: {
    BirthdayPicker,
    UploadDocument,
    UploadSingleFile,
  },
  computed: {
    moment() {
      return moment;
    },
    input() {
      return this.$store.state.input;
    },
  },
  data() {
    return {
      jobOptions: [
        "ผู้รับเหมา",
        "ช่างสี",
        "ช่างไม้",
        "ช่างฝ้า",
        "ช่างปูกระเบื้อง",
        "ช่างซ่อมบำรุง/ช่างฝีมือทั่วไป",
        "สถาปนิก / อินทีเรีย /  ดีไซเนอร์",
        "อื่นๆ",
      ],
      saveloading: false,
    };
  },
  mounted() {
    Object.assign(this.$store.state.input, this.$store.state.member);
  },
  methods: {
    async next() {
      if (await this.$refs.observer.validate()) {
        this.saveloading = true;
        var data = {
          memberId: this.$store.state.member.memberId, // required
          firstName: this.input.firstName,
          lastName: this.input.lastName,
          dob: this.input.dob,
          job: this.input.job,
          email: this.input.email,
          identityNumberImage: this.input.identityNumberImage,
        };
        axios
          .put(this.serverUrl + "toacrm/edit-member", data, {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
          })
          .then(async (response) => {
            if (response.data.responsecode == 200) {
              Object.assign(this.$store.state.member, {
                firstName: this.input.firstName,
                lastName: this.input.lastName,
                dob: this.input.dob,
                job: this.input.job,
                email: this.input.email,
                identityNumberImage: this.input.identityNumberImage,
              });
              this.$emit("close");
            } else {
              await this.$swal.fire({
                text: response.data.reason,
              });
              if (response.data.responsecode == 400) {
                this.$liff.closeWindow();
              }
            }
          });
      }
    },
  },
};
</script>

<style lang="scss">
.titleprofile {
  color: #9f9f9f;
}

.valueprofile {
  font-size: 23px;
}
</style>
